import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
// import useSpan from '../../hooks/useSpan';
import Spacer from './Spacer';

const ArticleHighlight = ({ style, text }) => (
  <>
    <Row>
      <Col
        xs={{
          offset: 3,
          span: 19,
        }}
        md={{ offset: 6, span: 11 }}
      >
        <p
          className={classNames(
            'article-highlight',
            `article-highlight--${style}`
          )}
        >
          {text}
        </p>
      </Col>
    </Row>
    <Spacer size="Mid" />
  </>
);

ArticleHighlight.propTypes = {
  style: PropTypes.oneOf(['one', 'two']).isRequired,
  text: PropTypes.string.isRequired,
};

export default ArticleHighlight;
